import { render, staticRenderFns } from "./hcaptcha.vue?vue&type=template&id=78ff2a37&"
import script from "./hcaptcha.vue?vue&type=script&lang=js&"
export * from "./hcaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ff2a37')) {
      api.createRecord('78ff2a37', component.options)
    } else {
      api.reload('78ff2a37', component.options)
    }
    module.hot.accept("./hcaptcha.vue?vue&type=template&id=78ff2a37&", function () {
      api.rerender('78ff2a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/hcaptcha.vue"
export default component.exports